import users from './users';
const data = [...users];

export default data;